
import apiCall from '@/utils/apiCall';

export default {
    /**
     * Load integations
     *
     * @param   {object}    store                   Vuex store.
     * @param   {Function}  store.commit            Method to commit a mutation.
     *
     */
    async loadIntegrations({ commit }) {
        const { status, data } = await apiCall(this._vm, 'get', '/api/integrations');

        if (200 !== status) {
            commit('setIntegrations', false);
        } else {
            commit('setIntegrations', data);
        }
    },
};
